import { render, staticRenderFns } from "./add-stock.vue?vue&type=template&id=54c6b746"
import script from "./add-stock.vue?vue&type=script&lang=js"
export * from "./add-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports